export default __webpack_public_path__ + "static/media/icon.43387bf6.png";